import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import {
  Dialog,
  DialogTitle,
  DialogActions,
  CircularProgress,
  IconButton,
  Tooltip,
  DialogContent,
  Typography
} from '@mui/material';

import { FaTrashAlt, FaArrowLeft, FaCheckCircle, FaTrash } from "react-icons/fa";

import { deleteDocLegal, getDocsLegal, clearErrors } from '../../../redux/actions/dataactions';
import './DocumentoEliminar.css';

class DocumentoEliminar extends Component {
  state = {
    open: false,
    errors: {},
    aprobado: {}
  };

  static getDerivedStateFromProps(props, state) {
    const newState = {};
    if (props.UI?.errors) newState.errors = props.UI.errors;
    if (props.UI?.aprobado) newState.aprobado = props.UI.aprobado;
    return Object.keys(newState).length ? newState : null;
  }

  handleOpen = () => {
    this.setState({ open: true, aprobado: {}, errors: {} });
  };

  handleClose = () => {
    this.props.clearErrors();
    if (this.state.aprobado?.mensaje) {
      this.setState({ open: false, aprobado: {}, errors: {} });
      this.props.getDocsLegal(this.props.clienteId);
    } else {
      this.setState({ open: false, errors: {} });
    }
  };

  deleteDocument = () => {
    this.props.deleteDocLegal(this.props.docId, this.props.clienteId);
  };

  render() {
    const { UI } = this.props;
    const { loading } = UI;
    const { open, aprobado, errors } = this.state;

    return (
      <Fragment>
        <Tooltip title="Eliminar Documento">
          <IconButton onClick={this.handleOpen}>
            <FaTrashAlt color="#03178C" className="documento-eliminar-icon" />
          </IconButton>
        </Tooltip>

        <Dialog open={open} onClose={this.handleClose} fullWidth maxWidth="sm">
          {aprobado?.mensaje ? (
            <div className='documento-eliminar-aprobado'>
              <div className='documento-eliminar-icono-container'>
                <FaTrash color="#ffffff" className='documento-eliminar-icono' />
              </div>
              <h2 className='documento-eliminar-texto'>Documento Borrado Exitosamente</h2>
            </div>
          ) : (
            <>
              <DialogTitle><Typography sx={{ 
                                                fontSize: '20px', 
                                                fontWeight: 400, 
                                                color: '#0468BF', 
                                                textAlign: 'start' 
                                                }}>
                                                ¿Estás seguro de Borrar este Documento?
                                </Typography></DialogTitle>
              <DialogContent>
                {errors?.error && (
                  <Typography color="error" sx={{ mt: 1 }}>
                    {errors.error}
                  </Typography>
                )}
              </DialogContent>
            </>
          )}

          <DialogActions>
            <Tooltip title="Cerrar">
              <IconButton onClick={this.handleClose}>
                <FaArrowLeft color="#D3D7DC" className="documento-eliminar-form-icon" />
              </IconButton>
            </Tooltip>

            {loading ? (
              <CircularProgress size={30} color="primary" className="documento-eliminar-progress" />
            ) : aprobado?.mensaje ? (
              <Tooltip title="Continuar">
                <IconButton onClick={this.handleClose}>
                  <FaCheckCircle color="#f9044e" className="documento-eliminar-form-icon" />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Borrar Documento">
                <IconButton onClick={this.deleteDocument}>
                  <FaTrash color="#03178C" className="documento-eliminar-form-icon" />
                </IconButton>
              </Tooltip>
            )}
          </DialogActions>
        </Dialog>
      </Fragment>
    );
  }
}

DocumentoEliminar.propTypes = {
  deleteDocLegal: PropTypes.func.isRequired,
  getDocsLegal: PropTypes.func.isRequired,
  clearErrors: PropTypes.func.isRequired,
  docId: PropTypes.string.isRequired,
  clienteId: PropTypes.string.isRequired,
  UI: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
  UI: state.UI
});

export default connect(mapStateToProps, { deleteDocLegal, clearErrors, getDocsLegal })(DocumentoEliminar);
